<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card class="py-5">
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Sales Report
                    <div class="month-label">
                      {{
                        `${formatDate(this.dates[0])} - ${formatDate(
                          this.dates[1]
                        )}`
                      }}
                      Report
                    </div>
                  </v-toolbar-title>
                </div>
                <div class="ml-auto d-flex">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="dates"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-calendar</v-icon> Choose Date
                        Range
                      </v-btn>
                    </template>
                    <v-date-picker v-model="dates" range>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(dates)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>
              </div>
            </v-col>
            <!-- <v-spacer></v-spacer> -->
          </v-toolbar>

          <!-- <v-divider></v-divider> -->
        </v-card>
      </v-col>

      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Sales Report
                  </v-toolbar-title>
                </div>
                <div class="ml-auto">
                  <v-btn color="primary" class="ml-auto">
                    <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <!-- <template
        v-for="header in headers.filter((header) =>
          header.hasOwnProperty('formatter')
        )"
        v-slot:[`item.${header.value}`]="{ value }"
      >
        {{ header.formatter(value) }}
      </template> -->

            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.isPaid`]="{ item }">
              {{ item.isPaid ? "Yes" : "No" }}
            </template>

            <template v-slot:[`item.fullname`]="{ item }">
              <a
                href="#"
                @click.prevent="showDetails(item, 'retailer-daily-total-sales')"
                >{{ `${item.fullname}` }}</a
              >
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn x-small color="pink" dark @click="editDrawDetail(item)">
                Edit</v-btn
              >
            </template>

            <template v-slot:[`item.summary.totalSales`]="{ item }">
              <span v-if="item.summary.totalSales">
                <a
                  href="#"
                  @click.prevent="showDetails(item, 'subscriber-transactions')"
                  >{{ setToLocaleString(item.summary.totalSales) }}</a
                >
              </span>

              <span v-else>0</span>
            </template>

            <!-- <template v-slot:[`item.firstName`]="{ item }">
              <a
                href="#"
                @click="showDetails(item, 'retailer-daily-total-sales')"
                >{{ item.firstName }}</a
              >
            </template> -->
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <AddSalesAgentDialog
      :dialog="addSaleAgent.dialog"
      @close="addSaleAgent.dialog = !addSaleAgent.dialog"
      @response="addSalesAgentResponse"
    ></AddSalesAgentDialog>

    <RetailerViewSales
      :dialog="retailerViewSales.dialog"
      :data="retailerViewSales.data"
      :reportName="retailerViewSales.reportName"
      @close="retailerViewSales.dialog = !retailerViewSales.dialog"
    >
    </RetailerViewSales>
  </v-container>
</template>

<script>
import moment from "moment";
import AddSalesAgentDialog from "../dialogs/AddSalesAgentDialog.vue";
import RetailerViewSales from "../dialogs/dealer/RetailerViewSales.vue";
import ShareableMethods from "@/mixins/ShareableMethods";
export default {
  mixins: [ShareableMethods],
  name: "DeleaerRetailerList",
  components: {
    AddSalesAgentDialog,
    RetailerViewSales,
  },
  data() {
    return {
      exportData: [],
      fileName: "",

      retailerViewSales: {
        dialog: false,
        data: {},
        reportName: "",
      },
      dates: [
        moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        moment()
          .endOf("month")
          .format("YYYY-MM-DD"),
      ],
      menu: false,
      modal: false,

      addSaleAgent: {
        dialog: false,
      },

      search: "",
      table: {
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,

        headers: [
          {
            text: "Full Name",
            align: "start",
            value: "fullname",
            // formatter: (fname, lname) => ( `${fname} ${lname}`),
          },

          {
            text: "Dealer",
            align: "start",
            value: "dealerFullname",
          },
          {
            text: "Mobile Number",
            align: "start",
            value: "mobileNumber",
          },
          {
            text: "From (Date)",
            align: "start",
            value: "summary.fromDate",
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
          },

          {
            text: "To (Date)",
            align: "start",
            value: "summary.toDate",
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
          },
          {
            text: "Total Sales",
            align: "start",
            value: "summary.totalSales",
          },

          // {
          //   text: "Date",
          //   align: "start",
          //   sortable: false,
          //   value: "createdDate",
          //   formatter: (x) =>
          //     // x ? moment(x).format("MMM DD, YYYY h:mm:ss A") : null,
          //     x ? moment(x).format("MMM DD, YYYY") : null,
          // },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$api
        .get(
          `/acquisition/report?report=retailers-sales-report&startDate=${this.dates[0]}&endDate=${this.dates[1]}`
        )
        .then((response) => {
          // console.log(response);
          const newArr = response.data.data.retailers;
          console.log(newArr);
          this.table.data = newArr;

          let exportData = newArr.map((item) => {
            return {
              Name: item.fullname,
              Dealer: item.dealerFullname,
              "Mobile Number": item.mobileNumber,
              "From (Date)": moment(item.summary.fromDate).format(
                "MMM DD, YYYY"
              ),
              "To (Date)": moment(item.summary.toDate).format("MMM DD, YYYY"),
              "Total Sales": item.summary.totalSales,
              // Date: moment(item.createdDate).format("MMM DD, YYYY"),
              // SKU: item.name,
              // Amount: item.amount,
            };
          });
          this.fileName = `Retailers_Sales_Report_${this.dates[0]}_${this.dates[1]}`;
          this.exportData = exportData;

          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    addSalesAgentResponse(res) {
      if (res) {
        this.getList();
        this.addSaleAgent.dialog = false;
      }
    },

    formatDate(d) {
      return moment(d).format("MMM DD, YYYY");
    },

    showDetails(data, reportName) {
      data.summary.fromDate = this.dates[0];
      data.summary.toDate = this.dates[1];

      this.retailerViewSales.reportName = reportName;
      this.retailerViewSales.data = data;
      this.retailerViewSales.dialog = true;

      return false;
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    dates() {
      this.getList();
    },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
